export default "__VITE_ASSET__CufCcrpb__"